import { type ReactNode } from 'react';
import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: block;
  float: right;
  margin: 0 0 20px 20px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MOBILE}) {
    margin-left: 0;
    width: 100%;
  }
`;

const Inner = styled.div`
  padding: 5px 0 5px 25px;
  font-size: 22px;
  line-height: 30px;
  border-left: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
  color: ${({ theme }) => theme.fontColor.DEFAULT};
  max-width: 300px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MOBILE}) {
    max-width: 100%;
  }
`;

interface BlogQuoteProps {
  children: ReactNode;
}

export const BlogQuote: React.ComponentType<BlogQuoteProps> = React.memo(
  ({ children }) => {
    return (
      <Wrapper>
        <Inner>{children}</Inner>
      </Wrapper>
    );
  }
);
